import * as React from "react"

import { cn } from "@/lib/utils"

function Table({
  className,
  ...props
}) {
  return (
    <div data-slot="table-container" className="relative font-[Dubai] w-full overflow-x-auto">
      <table
        data-slot="table"
        className={cn("w-full caption-bottom text-md", className)}
        {...props} />
    </div>
  );
}

function TableHeader({
  className,
  ...props
}) {
  return (
    <thead
      data-slot="table-header"
      className={cn("[&_tr]:border-b !font-bold", className)}
      {...props} />
  );
}

function TableBody({
  className,
  ...props
}) {
  return (
    <tbody
      data-slot="table-body "
      className={cn("[&_tr:last-child]:border-0 ", className)}
      {...props} />
  );
}

function TableFooter({
  className,
  ...props
}) {
  return (
    <tfoot
      data-slot="table-footer"
      className={cn("bg-muted/50 border-t font-medium [&>tr]:last:border-b-0", className)}
      {...props} />
  );
}

function TableRow({
  className,
  ...props
}) {
  return (
    <tr
      data-slot="table-row"
      className={cn(
        "hover:bg-muted/50 data-[state=selected]:bg-muted !h-18 transition-colors ",
        className
      )}
      {...props} />
  );
}

function TableHead({ className, sticky, ...props }) {
  return (
    <th
      data-slot="table-head"
      className={cn(
        "text-black h-10 px-2  text-left align-middle font-bold whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        sticky === 1 && "sticky left-0 z-20 bg-primary-foreground",         
        sticky === 2 && "sticky left-[100px] z-20 bg-primary-foreground", 
        className
      )}
      {...props}
    />
  );
}
function TableCell({ className, ...props }) {
  return (
    <td
      data-slot="table-cell"
      className={cn(
        "p-2 align-start  [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",

        className
      )}
      {...props}
    />
  );
}

function TableCaption({
  className,
  ...props
}) {
  return (
    <caption
      data-slot="table-caption"
      className={cn("text-muted-foreground mt-4 text-sm", className)}
      {...props} />
  );
}

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
}
